import "./header.css";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FiLogOut } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { logout } from "../../features/auth/authSlice";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  return (
    <>
      <header>
        <div className="upper-menu-block">
          <div className="our-container">
            <div className="inner-container main-header mx-auto">
              <div className="logo-block my-2">
                <Link to={"/dashboard"} className="d-block">
                  <img src="/images/logo.png" alt="" />
                </Link>
              </div>
              <div className="main-menu">
                <nav>
                  <ul className="p-0 main-sub-header mb-0 nav-links">
                    <li>
                      <NavLink
                        to={"/dashboard"}
                        className="fs-6 fw-semibold nav-items"
                      >
                        Enquiry
                      </NavLink>
                    </li>
                    <li className="">
                      <button
                        className="btn nav-link text-black fs-6 fw-semibold nav-items p-0 d-flex align-items-center"
                        type="button"
                        onClick={handleLogout}
                      >
                        <FiLogOut className="text-white fa-user-icon me-1" />
                        <span className="mb-0 text-white">Sign Out</span>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
